import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    label: String,
    labels: Array,
    data: Array,
    options: Object,
    backgrounds: Array
  }

  connect () {
    import("chart.js/auto").then(({ default: Chart }) => {
      const data = {
        labels: this.labelsValue,
        datasets: [{
          backgroundColor: this.backgroundsValue,
          data: this.dataValue
        }]
      }

      const config = {
        type: "doughnut",
        data: data,
        options: {
          plugins: {
            legend: {
              position: "left"
            },
            tooltip: {
              callbacks: {
                label: function (context) {
                  return context.label + ": " + context.formattedValue + '%'
                }
              }
            }
          }
        }
      }

      this.chart = new Chart(this.element, config)
    })
  }

  disconnect () {
    this.chart.destroy()
    this.chart = undefined
  }
}
